"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVM = void 0;
const ethers_1 = require("ethers");
const sigUtil = __importStar(require("@metamask/eth-sig-util"));
const axios_1 = __importDefault(require("axios"));
const erc20_1 = __importDefault(require("./utils/abis/erc20"));
const abi_1 = require("./utils/abi");
const constants_1 = require("../../helper/constants");
const checksum_1 = require("../../helper/checksum");
// import Decimal from 'decimal.js';
// import { getBalanceInTokens } from '../../helper/format';
const erc1155_1 = require("./utils/abis/erc1155");
const erc721_1 = require("./utils/abis/erc721");
const CouponsAbi_1 = require("./utils/abis/CouponsAbi");
const adapter_1 = require("./utils/adapter");
const user_1 = __importDefault(require("../../../services/user"));
/**
 * EVM Class for all interactions with EVM compatible chains
 *
 * we use the rpcUrl for making chain provider
 * and chainId for swap on 1inch api
 *
 * https://docs.1inch.io/docs/aggregation-protocol/api/swagger
 */
class EVM {
    /**
     * In case of EVM, uses the rpcUrl to make a provider
     *
     * Sets the chain id and provider instance
     *
     * @param chainId - A chain id for using 1inch apis.
     * @param rpcUrl - A rpcUrl for the provider
     */
    constructor(baseUrl, chainId, rpcUrl, chainName, walletType) {
        this.okxDexApiUrl = 'https://www.okx.com/api/v5/dex/aggregator';
        this.walletType = walletType;
        // console.log(`EVM chain instance for ${chainId} ${chainName}`, { walletType });
        // this.providerInstance = providerInstance;
        this.rpcUrl = rpcUrl;
        this.chainId = chainId;
        this.chainName = chainName;
        this.triaApiBaseUrl = `${baseUrl}/api/v1`;
        this.userService = new user_1.default(baseUrl);
    }
    /**
     * Get RPC provider for embedded or external wallet
     *
     * @returns providerInstance
     */
    getProvider() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let providerInstance;
            if (((_a = this.walletType) === null || _a === void 0 ? void 0 : _a.embedded) || !this.walletType) {
                providerInstance = new ethers_1.ethers.providers.JsonRpcProvider(this.rpcUrl);
            }
            else {
                const provider = yield (0, adapter_1.getEthersProvider)({ chainId: this.chainId });
                providerInstance = provider;
            }
            return providerInstance;
        });
    }
    waitForTransaction(txnHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const provider = yield this.getProvider();
            const txn = yield provider.waitForTransaction(txnHash);
            return txn;
        });
    }
    /**
     * Derives new wallet for a chain using mnemonic and derivation path
     *
     * Returns the publicKey and privateKey
     *
     * @param mnemonic - An account address.
     * @param derivationPath - derivation path chain specific and derivationIndex calc?
     * @param derivationPathIndex - index
     * @returns The public key and private key.
     */
    createWallet(mnemonic, derivationPathIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = ethers_1.ethers.Wallet.fromMnemonic(mnemonic, `m/44'/60'/0'/0/${derivationPathIndex}`);
            return {
                address: wallet.address,
                privateKey: wallet.privateKey,
            };
        });
    }
    getTokenDetails(tokenAddress, accountAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let name, symbol, decimals, balance;
                if (tokenAddress) {
                    const { contract } = yield this.getContract(tokenAddress);
                    name = yield contract.name();
                    symbol = yield contract.symbol();
                    decimals = yield contract.decimals();
                    if (accountAddress)
                        balance = yield contract.balanceOf(accountAddress);
                }
                else {
                    //@ts-ignore
                    name = constants_1.nativeTokenDetails[this.chainName].name;
                    //@ts-ignore
                    symbol = constants_1.nativeTokenDetails[this.chainName].symbol;
                    decimals = 18;
                    if (accountAddress) {
                        const provider = yield this.getProvider();
                        balance = yield provider.getBalance(accountAddress);
                    }
                }
                return {
                    name,
                    symbol,
                    decimals,
                    balance,
                };
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * Gets balance for native token or asset
     *
     * Returns the currently initialized keyring that manages
     * the specified `address` if one exists.
     *
     * @param accountAddress - An account address.
     * @param tokenAddress - A asset contract address
     * @returns The keyring of the account, if it exists.
     */
    getBalance(accountAddress, tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { name, symbol, decimals, balance } = yield this.getTokenDetails(tokenAddress, accountAddress);
                return {
                    name,
                    symbol,
                    balance: parseFloat(decimals ? ethers_1.ethers.utils.formatUnits(balance, decimals) : ethers_1.ethers.utils.formatEther(balance)),
                    balanceInUnits: balance.toString(), // bignumber
                    decimals,
                };
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     *
     * @param data Encrypt data with user's public key.
     * @param publicKey
     * @returns
     */
    encrypt(signer, data, address, version) {
        return __awaiter(this, void 0, void 0, function* () {
            const publicKey = yield signer.provider.send('eth_getEncryptionPublicKey', [address]);
            const result = sigUtil.encrypt({
                publicKey,
                data,
                version: version || 'x25519-xsalsa20-poly1305',
            });
            return { success: true, data: JSON.stringify(result) };
        });
    }
    /**
     * Decrypt data with private key
     * @param signer
     * @param encryptedData
     * @param address
     * @returns
     */
    decrypt(signer, encryptedData, address) {
        return __awaiter(this, void 0, void 0, function* () {
            const userAddress = address ? address : yield signer.getAddress();
            const result = yield signer.provider.send('eth_decrypt', [encryptedData, userAddress]);
            return { success: true, data: result };
        });
    }
    /**
     * Checks the validity of a txn based on the balance and transfer amount.
     *
     *
     * @param accountAddress - An account address.
     * @param amount - Amount to transfer
     * @param tokenAddress - A asset contract address // optional
     * @returns The keyring of the account, if it exists.
     */
    checkSendValidity(accountAddress, amount, tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            let { balanceInUnits: accountBalance, decimals } = yield this.getBalance(accountAddress, tokenAddress);
            let transferAmount = decimals
                ? ethers_1.ethers.utils.parseUnits(amount.toFixed(decimals), decimals)
                : ethers_1.ethers.utils.parseEther(amount.toFixed(18));
            // console.log({ transferAmount: transferAmount.toString(), accountBalance });
            return transferAmount.lt(ethers_1.ethers.BigNumber.from(accountBalance));
        });
    }
    /**
     * Sends the token amount
     *
     * @param signer - for signing txns
     * @param tokenAddress - if transferring a ERC20 token
     * @param amount - amount to transfer
     *
     * @returns Returns the txn object or hash - tbd
     */
    send({ signer, fromAddress, tokenAddress, recipientAddress, amount, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.getSendTxnObject(fromAddress, recipientAddress, amount, tokenAddress);
            if (res.success && (res === null || res === void 0 ? void 0 : res.txnObject)) {
                const txnRes = yield this.broadcastTransaction(signer, res === null || res === void 0 ? void 0 : res.txnObject);
                return txnRes;
            }
            else
                return res;
        });
    }
    getSendFee(fromAddress, recipientAddress, amount, tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('getSendTxnObject');
            const res = yield this.getSendTxnObject(fromAddress, recipientAddress, amount, tokenAddress);
            if (res.success) {
                const fee = yield this.getEstimateFee(res.txnObject);
                return fee;
            }
            else {
                return res;
            }
        });
    }
    getSendTxnObject(fromAddress, recipientAddress, amount, tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            // const valid = await this.checkSendValidity(
            //   fromAddress as string,
            //   amount, // in number, e.g. 0.1 ETH
            //   tokenAddress as string
            // );
            // const { gasPrice, gasLimit, nonce } = await this.getGasDetailsAndNonce(fromAddress);
            // if (valid)
            try {
                let txnObject;
                if (tokenAddress) {
                    const { contract } = yield this.getContract(tokenAddress);
                    const decimals = yield contract.decimals();
                    console.log({ decimals });
                    txnObject = yield contract.populateTransaction.transfer(recipientAddress, ethers_1.ethers.utils.parseUnits(amount.toFixed(decimals), decimals)
                    // {
                    //   gasPrice,
                    //   nonce,
                    // }
                    );
                    console.log({ res: txnObject });
                }
                else {
                    txnObject = {
                        to: recipientAddress,
                        value: ethers_1.ethers.utils.parseEther(amount.toFixed(18)),
                        // gasPrice,
                        // nonce,
                        data: '0x',
                    };
                }
                return { success: true, txnObject: Object.assign(Object.assign({}, txnObject), { from: fromAddress }) };
            }
            catch (error) {
                throw error;
                console.error(error);
                return { success: false, message: 'Error creating send txn object' };
            }
            // else return { success: false, message: 'Not a valid txn, insufficient funds' };
        });
    }
    /**
     * Swap tokens using 1inch aggregator
     *
     * Swap from asset to asset working
     * Naitve token to asset params to be figured out
     *
     * @param signer - to broadcast swap txn
     * @param fromTokenAddress - token to be swapped
     * @param toTokenAddress - token to be returned
     * @param amount - from amount - in number e.g. 0.1 ETH
     * @param fromAddress - address performing txn
     * @param slippage - in percentage e.g. 1%
     *
     */
    swap({ signer, fromTokenAddress, toTokenAddress, amount, slippage }) {
        return __awaiter(this, void 0, void 0, function* () {
            const fromAddress = yield signer.getAddress();
            const res = yield this.getSwapTxnObject(fromAddress, fromTokenAddress, toTokenAddress, amount, slippage);
            if (res.success && (res === null || res === void 0 ? void 0 : res.txnObject)) {
                const txnRes = yield this.broadcastTransaction(signer, res === null || res === void 0 ? void 0 : res.txnObject);
                return txnRes;
            }
            else {
                return res;
            }
        });
    }
    getSwapTxnObject(fromAddress, fromTokenAddress, toTokenAddress, amount, slippage) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('getSwapTxnObject');
            let contract;
            if (fromTokenAddress) {
                const res = yield this.getContract(fromTokenAddress);
                contract = res.contract;
            }
            const decimals = contract ? yield (contract === null || contract === void 0 ? void 0 : contract.decimals()) : 18;
            console.log({ decimals });
            const spender = yield this.get1inchRouterContractAddress();
            const valid = yield this.checkTokenAllowance({
                accountAddress: fromAddress,
                tokenAddress: fromTokenAddress,
                amount,
                spender,
            });
            console.log({ valid });
            const parsedAmount = ethers_1.ethers.utils.parseUnits(amount.toFixed(decimals), decimals).toString();
            const swapParams = {
                fromTokenAddress,
                toTokenAddress,
                parsedAmount,
                fromAddress,
                slippage: slippage.toString(),
            };
            if (valid) {
                let txnObject;
                if (this.chainId == 66) {
                    const res = yield this.swapOnOkx(swapParams);
                    if (res.success) {
                        txnObject = res === null || res === void 0 ? void 0 : res.txnObject;
                    }
                    else
                        return res;
                }
                else {
                    const res = yield this.swapOn1inch(swapParams);
                    if (res.success) {
                        txnObject = res === null || res === void 0 ? void 0 : res.txnObject;
                    }
                    else
                        return res;
                }
                return { success: true, txnObject };
            }
            else
                return { success: false, message: 'Invalid swap txn, increase allowance' };
        });
    }
    getSwapFee(fromAddress, fromTokenAddress, toTokenAddress, amount, slippage) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.getSwapTxnObject(fromAddress, fromTokenAddress, toTokenAddress, amount, slippage);
            if (res.success) {
                const fee = yield this.getEstimateFee(res.txnObject);
                return fee;
            }
            else {
                return res;
            }
        });
    }
    getEstimateFee(txnObject) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                console.log('estimating gas..', txnObject);
                const provider = yield this.getProvider();
                const estimatedGas = yield provider.estimateGas(txnObject);
                console.log('gas', estimatedGas.toString());
                const gasPrice = yield provider.getGasPrice();
                const tokenData = yield this.userService.getTokenData(this.chainName);
                const gasFeeInWei = estimatedGas.mul(gasPrice);
                const gasFeeInEth = ethers_1.ethers.utils.formatEther(gasFeeInWei); // string
                // console.log({ gasFeeInEth });
                let gasFeeInUsd;
                if ((tokenData === null || tokenData === void 0 ? void 0 : tokenData.usd) >= 0) {
                    gasFeeInUsd = parseFloat(gasFeeInEth) * (tokenData === null || tokenData === void 0 ? void 0 : tokenData.usd);
                }
                return { success: true, fee: { eth: gasFeeInEth, usd: gasFeeInUsd === null || gasFeeInUsd === void 0 ? void 0 : gasFeeInUsd.toString() } };
            }
            catch (err) {
                console.error(err);
                return {
                    success: false,
                    message: 'Insufficient gas or error while estimating fee',
                    error: err,
                };
            }
        });
    }
    getSwapTargets(fromTokenAddress, listLength, query) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield axios_1.default.get(`${this.triaApiBaseUrl}/chain/${this.chainId}/tokens`);
                const tokens = data === null || data === void 0 ? void 0 : data.tokens;
                let swapTargets = [];
                for (let [key, token] of Object.entries(tokens)) {
                    // @ts-ignore
                    const tokenAddress = token === null || token === void 0 ? void 0 : token.address;
                    const target = {
                        // @ts-ignore
                        name: token === null || token === void 0 ? void 0 : token.name,
                        // @ts-ignore
                        symbol: token === null || token === void 0 ? void 0 : token.symbol,
                        tokenAddress: tokenAddress !== '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'
                            ? (0, checksum_1.checksumAddress)(tokenAddress)
                            : null,
                        // @ts-ignore
                        logoUrl: token === null || token === void 0 ? void 0 : token.logoURI,
                        // decimals
                    };
                    if (target.tokenAddress === fromTokenAddress)
                        continue;
                    if (!query)
                        swapTargets.push(target);
                    // @ts-ignore
                    else if (query && (token === null || token === void 0 ? void 0 : token.symbol.toLowerCase().includes(query.toLowerCase()))) {
                        swapTargets.push(target);
                    }
                }
                return swapTargets.slice(0, listLength);
            }
            catch (error) {
                // throw new Error(`Error swapping token ${fromTokenAddress}: `);
                throw new Error(error);
            }
        });
    }
    stake(signer, address, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const MY_REWARDS_ADDRESS = address; // same as user // 'YOUR_REWARDS_ADDRESS';
            const { contract: lidoContract } = yield this.getContract(abi_1.LIDO_ADDRESS, signer, abi_1.LIDO_ABI);
            const txnObject = lidoContract.submit(MY_REWARDS_ADDRESS, {
                from: address,
                value: ethers_1.ethers.utils.parseEther(amount.toFixed(18)),
            });
            const txnRes = yield this.broadcastTransaction(signer, txnObject);
            return txnRes;
        });
    }
    /**
     * Approve tokens to be spent by 1inch router contract
     *
     * @param signer
     * @param tokenAddress - token contract address to be swapped
     * @param accountAddress
     * @returns
     */
    approve({ signer, fromAddress, tokenAddress, amount, spender, }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!tokenAddress)
                return { success: false, message: 'Token address is null' };
            console.log({ fromAddress, tokenAddress, amount });
            const res = yield this.getApproveTxnObject(fromAddress, tokenAddress, amount, spender);
            if (res.success && (res === null || res === void 0 ? void 0 : res.txnObject)) {
                console.log('broadcasting approve');
                console.log('res?.txnObject ', res === null || res === void 0 ? void 0 : res.txnObject);
                const txnRes = yield this.broadcastTransaction(signer, res === null || res === void 0 ? void 0 : res.txnObject);
                return txnRes;
            }
            else
                return res;
        });
    }
    getApproveFee(fromAddress, tokenAddress, amount, spender) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!tokenAddress)
                return { success: false, message: 'Token address is null' };
            const res = yield this.getApproveTxnObject(fromAddress, tokenAddress, amount, spender);
            if (res.success) {
                console.log('res.txnObject ', res.txnObject);
                const fee = yield this.getEstimateFee(res.txnObject);
                return fee;
            }
            else {
                return res;
            }
        });
    }
    getApproveTxnObject(fromAddress, tokenAddress, amount, spender) {
        return __awaiter(this, void 0, void 0, function* () {
            const { contract } = yield this.getContract(tokenAddress);
            const decimals = yield contract.decimals();
            const parsedAmount = ethers_1.ethers.utils.parseUnits(amount.toFixed(decimals), decimals);
            try {
                const txnObject = yield contract.populateTransaction.approve(spender, parsedAmount);
                return { success: true, txnObject: Object.assign(Object.assign({}, txnObject), { from: fromAddress }) };
            }
            catch (error) {
                // throw error;
                return { success: false, message: `Error approving token.` };
            }
        });
    }
    // async getApproveTxnObject(
    //   fromAddress: string,
    //   tokenAddress: string,
    //   amount: number,
    //   contractAddress: string
    // ): Promise<TxnObjectResponse> {
    //   const { contract } = await this.getContract(tokenAddress);
    //   const decimals = await contract.decimals();
    //   const parsedAmount = ethers.utils.parseUnits(amount.toString(), decimals);
    //   try {
    //     /* or get spenderAddress, i.e., 1inch router contract address
    //       and call approve function
    //     */
    //     let txnObject;
    //     if (this.chainId == 66) {
    //       // OKX
    //       const res = await this.approveOnOkx({
    //         tokenAddress,
    //         parsedAmount: parsedAmount.toString(),
    //         fromAddress,
    //       });
    //       if (res.success) {
    //         txnObject = res?.txnObject;
    //       } else return res;
    //     } else {
    //       // Other EVMs except CELO
    //       const res = await this.approveOn1inch({ tokenAddress, parsedAmount });
    //       if (res.success) {
    //         txnObject = res?.txnObject;
    //       } else return res;
    //     }
    //     console.log({ parsedAmount, txnObject, fromAddress });
    //     return {
    //       success: true,
    //       txnObject: {
    //         ...txnObject,
    //         from: fromAddress,
    //         gasPrice: ethers.utils.hexlify(parseInt(txnObject?.gasPrice)),
    //         value: ethers.utils.hexlify(parseInt(txnObject?.value)),
    //       },
    //     };
    //   } catch (error: any) {
    //     // throw error;
    //     return { success: false, message: `Error approving tokens on 1inch ${tokenAddress}` };
    //   }
    // }
    swapOn1inch({ fromTokenAddress, toTokenAddress, parsedAmount, fromAddress, slippage, }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            console.log('swapOn1inch');
            try {
                const { data } = yield axios_1.default.get(`${this.triaApiBaseUrl}/chain/${this.chainId}/swap`, {
                    params: {
                        fromTokenAddress,
                        toTokenAddress,
                        fromAddress,
                        parsedAmount,
                        slippage,
                    },
                });
                const swapTxnObject = Object.assign(Object.assign({}, data.tx), { gasLimit: ethers_1.ethers.utils.hexlify(data.tx.gas), 
                    // not working hexlifying these.
                    gasPrice: ethers_1.ethers.utils.hexlify(parseInt(data.tx.gasPrice)), value: ethers_1.ethers.utils.hexlify(parseInt(data.tx.value)) });
                delete swapTxnObject['gas'];
                console.log({ swapOn1inch: swapTxnObject });
                return { success: true, txnObject: swapTxnObject };
            }
            catch (error) {
                // throw new Error(`Error swapping token ${fromTokenAddress}: `);
                // throw error;
                return {
                    success: false,
                    message: ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.description) || 'Error estimating swap details, check if enough gas',
                };
            }
        });
    }
    swapOnOkx({ fromTokenAddress, toTokenAddress, parsedAmount, fromAddress, slippage, }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data: swapData } = yield axios_1.default.get(`${this.okxDexApiUrl}/swap`, {
                    params: {
                        chainId: this.chainId,
                        fromTokenAddress,
                        toTokenAddress,
                        amount: parsedAmount,
                        userWalletAddress: fromAddress,
                        slippage: slippage, // in percent 0.5 -> 0.5%
                    },
                });
                const { data, from, gasPrice, gas, to, value } = swapData.data[0].tx;
                // console.log({ gasPrice, gas });
                const swapTxnObject = {
                    data,
                    from,
                    gasPrice: ethers_1.ethers.utils.hexlify(parseInt(gasPrice)),
                    gasLimit: ethers_1.ethers.utils.hexlify(parseInt(gas)),
                    to,
                    value: ethers_1.ethers.utils.hexlify(parseInt(value)),
                };
                return { success: true, txnObject: swapTxnObject };
            }
            catch (error) {
                // throw new Error(`Error swapping token ${fromTokenAddress}: `);
                // throw new Error(error);
                return {
                    success: false,
                    message: ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.description) || 'Error estimating swap details, try increasing slippage',
                };
            }
        });
    }
    approveOn1inch({ tokenAddress, parsedAmount }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                /* or get spenderAddress, i.e., 1inch router contract address
                  and call approve function
                */
                const { data: approveTxnObject } = yield axios_1.default.get(`${this.triaApiBaseUrl}/chain/${this.chainId}/approve/transaction`, {
                    params: {
                        tokenAddress,
                        parsedAmount /* if not mentioned, approves infinite amount */,
                    },
                });
                return { success: true, txnObject: approveTxnObject };
            }
            catch (error) {
                // throw new Error(`Error approving tokens on 1inch ${tokenAddress}: `);
                // throw new Error(error);
                return { success: false, message: 'Error creating approve txn object' };
            }
        });
    }
    approveOnOkx({ tokenAddress, parsedAmount, fromAddress }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                /* or get spenderAddress, i.e., 1inch router contract address
                  and call approve function
                */
                const { data } = yield axios_1.default.get(`${this.okxDexApiUrl}/approve-transaction`, {
                    params: {
                        chainId: this.chainId,
                        tokenContractAddress: tokenAddress,
                        approveAmount: parsedAmount /* if not mentioned, approves infinite amount */,
                    },
                });
                const txnRes = data.data[0];
                const txnObject = {
                    data: txnRes.data,
                    from: fromAddress,
                    to: tokenAddress,
                    gasLimit: ethers_1.ethers.utils.hexlify(parseInt(txnRes.gasLimit)),
                    gasPrice: ethers_1.ethers.utils.hexlify(parseInt(txnRes.gasPrice)),
                    value: 0,
                };
                return { success: true, txnObject };
            }
            catch (error) {
                // throw new Error(`Error approving tokens on 1inch ${tokenAddress}: `);
                // throw new Error(error);
                return { success: false, message: 'Error making approve txn object on OKX' };
            }
        });
    }
    /**
     *
     * Checks allowance for the 1inch router contract address
     *
     * @param accountAddress - account holding tokens
     * @param tokenAddress - token to check allowance
     * @param amount - amount to be spent, e.g. 0.1 ETH
     *
     * @returns bool if allowance needed or not
     */
    checkTokenAllowance({ accountAddress, tokenAddress, amount, spender, }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!tokenAddress)
                return true;
            const { contract } = yield this.getContract(tokenAddress);
            const decimals = yield contract.decimals();
            const amountToSpend = ethers_1.ethers.utils.parseUnits(amount.toFixed(decimals), decimals);
            // let allowance;
            console.log('checkTokenAllowance', { accountAddress, tokenAddress, amount, spender });
            // if (this.chainId == 66) {
            //   // OKX
            //   allowance = await this.getAllowanceOnOkx({ accountAddress, tokenAddress });
            //   allowance = ethers.BigNumber.from(allowance);
            // } else {
            //   // allowance = await this.getAllowanceOn1inch({ accountAddress, tokenAddress });
            //   // const spender = await this.get1inchRouterContractAddress();
            //   allowance = await contract.allowance(accountAddress, spender);
            // }
            const allowance = yield contract.allowance(accountAddress, spender);
            console.log({
                allowanceNum: allowance.toString(),
                amountToSpendString: amountToSpend.toString(),
            });
            return allowance >= amountToSpend;
        });
    }
    // async getAllowanceOn1inch({ accountAddress, tokenAddress }: any) {
    //   try {
    //     const {
    //       data: { allowance },
    //     } = await axios.get(`${this.oneinchApiBaseUrl}/${this.chainId}/approve/allowance`, {
    //       headers: {
    //         Accept: 'application/json',
    //         Authorization: `Bearer ${this.oneinchApiKey}`,
    //       },
    //       params: {
    //         tokenAddress: tokenAddress,
    //         walletAddress: accountAddress,
    //       },
    //     });
    //     console.log(allowance);
    //     return allowance;
    //   } catch (err) {
    //     throw err;
    //   }
    // }
    getAllowanceOnOkx({ accountAddress, tokenAddress }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield axios_1.default.get(`${this.okxDexApiUrl}/get-allowance`, {
                    params: {
                        chainId: this.chainId,
                        userWalletAddress: accountAddress,
                        tokenContractAddress: tokenAddress,
                    },
                });
                const allowance = data.data[0].allowanceAmount; // string "0"
                return allowance;
            }
            catch (err) {
                throw err;
            }
        });
    }
    /**
     * Broadcasts the txn on-chain.
     *
     * @param signer
     * @param txnObject - Txn object data to broadcast
     * @returns
     */
    broadcastTransaction(signer, txnObject) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const txn = yield signer.sendTransaction(txnObject);
                // await txn.wait();
                return {
                    success: true,
                    data: {
                        txnId: txn.hash,
                        // @ts-ignore
                        viewInExplorer: `${constants_1.txnBaseUrl[this.chainName]}/${txn.hash}`,
                        wait: txn.wait,
                    },
                };
            }
            catch (error) {
                throw error;
                console.error(error);
                return {
                    success: false,
                    message: 'Error signing transaction.',
                };
            }
        });
    }
    /**
     * Helper function for creating contract instance
     *
     * Returns the contract instance
     *
     * TODO - add error handling for invalid erc20 contract addresss
     *
     * @param contractAddress - An account address.
     * @param abi - A asset contract address
     * @returns The contract instance.
     */
    getContract(contractAddress, signer, abi) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const contractAbi = abi || erc20_1.default;
                const contract = new ethers_1.ethers.Contract(contractAddress, contractAbi, signer ? signer : yield this.getProvider());
                return {
                    contract,
                };
            }
            catch (err) {
                throw new Error('Error making contract instance');
            }
        });
    }
    callContract(contractDetails, signer) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const fromAddress = yield signer.getAddress();
                const res = yield this.createCallContractTxnObject(contractDetails, fromAddress);
                if (res.success && (res === null || res === void 0 ? void 0 : res.txnObject)) {
                    const txnRes = yield this.broadcastTransaction(signer, res === null || res === void 0 ? void 0 : res.txnObject);
                    return txnRes;
                }
                else
                    return res;
            }
            catch (error) {
                console.error('Error interacting with the contract:', error);
                throw error;
            }
        });
    }
    getCallContractFee(contractDetails, fromAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.createCallContractTxnObject(contractDetails, fromAddress);
            if (res.success) {
                const fee = yield this.getEstimateFee(res.txnObject);
                return fee;
            }
            else {
                return res;
            }
        });
    }
    createCallContractTxnObject(contractDetails, fromAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { contractAddress, abi, functionName, args, value } = contractDetails;
                const { contract } = yield this.getContract(contractAddress, undefined, abi);
                // const { gasPrice, nonce } = await this.getGasDetailsAndNonce(fromAddress);
                // Invoke the contract function
                const txnObject = yield contract.populateTransaction[functionName](...args, {
                    value: value ? ethers_1.ethers.utils.parseEther(value.toFixed(18)) : 0,
                    // gasPrice,
                    // nonce,
                });
                // Handle the result
                console.log('createCallContractTxnObject', txnObject);
                return { success: true, txnObject: Object.assign(Object.assign({}, txnObject), { from: fromAddress }) };
            }
            catch (error) {
                throw error;
                console.error(error);
                return { success: false, message: 'Error creating contract calling txn object' };
            }
        });
    }
    readContract(contractDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { contractAddress, abi, functionName, args } = contractDetails;
                const { contract } = yield this.getContract(contractAddress, undefined, abi);
                // Invoke the contract function
                const data = yield contract[functionName](...args);
                // Handle the result
                console.log('readContract', data);
                return { success: true, data };
            }
            catch (error) {
                console.error(error);
                return { success: false, message: 'Error reading contract', error };
            }
        });
    }
    /**
     * Helper function for creating signer and getting nonce and gas
     *
     * @param privateKey - A private key.
     * @returns The signer, nonce, gas, gasPrice.
     */
    getSigner(privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const signer = privateKey
                ? new ethers_1.ethers.Wallet(privateKey, yield this.getProvider())
                : (yield (0, adapter_1.getEthersSigner)({ chainId: this.chainId }));
            return {
                signer,
            };
        });
    }
    getGasDetailsAndNonce(fromAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const provider = yield this.getProvider();
            const gasPrice = (yield provider.getFeeData()).gasPrice; // await getProvider().getGasPrice();
            const gasLimit = 21000;
            const nonce = yield provider.getTransactionCount(fromAddress);
            return {
                nonce,
                gasPrice,
                gasLimit,
            };
        });
    }
    signMessage(signer, message) {
        return __awaiter(this, void 0, void 0, function* () {
            const signature = yield signer.signMessage(message);
            return signature;
        });
    }
    getTxnDetails(txnHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const provider = yield this.getProvider();
            const txn = yield provider.getTransactionReceipt(txnHash);
            return txn; // status -> 0,1
        });
    }
    isContractAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const checkSumAddress = ethers_1.ethers.utils.getAddress(address);
                const provider = yield this.getProvider();
                const code = yield provider.getCode(checkSumAddress);
                if (code !== '0x')
                    return true;
                else
                    return false;
            }
            catch (error) {
                // throw error;
                return false;
            }
        });
    }
    isERC20Address(address) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const checkSumAddress = ethers_1.ethers.utils.getAddress(address);
                const { contract } = yield this.getContract(checkSumAddress);
                yield contract.balanceOf(checkSumAddress);
                yield contract.decimals();
                yield contract.totalSupply();
                return true;
            }
            catch (error) {
                console.log('Not erc20 contract');
                return false;
            }
        });
    }
    is1inchRouterContract(address) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const routerAddress = yield this.get1inchRouterContractAddress();
                if (address.toLowerCase() === routerAddress.toLowerCase())
                    return true;
                else
                    return false;
            }
            catch (error) {
                return false;
            }
        });
    }
    get1inchRouterContractAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data: { address: routerAddress }, } = yield axios_1.default.get(`${this.triaApiBaseUrl}/chain/${this.chainId}/approve/spender`);
                return routerAddress;
            }
            catch (err) {
                throw new Error('Unable to fetch 1inch router contract address');
            }
        });
    }
    getSendNFTFee(fromAddress, recipientAddress, nftDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.getSendNFTTxnObject(fromAddress, recipientAddress, nftDetails);
            if (res.success) {
                const fee = yield this.getEstimateFee(res === null || res === void 0 ? void 0 : res.txnObject);
                return fee;
            }
            else
                return res;
        });
    }
    sendNFT(signer, fromAddress, recipientAddress, nftDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.getSendNFTTxnObject(fromAddress, recipientAddress, nftDetails);
            if (res.success) {
                const txnRes = yield this.broadcastTransaction(signer, res === null || res === void 0 ? void 0 : res.txnObject);
                return txnRes;
            }
            else
                return res;
        });
    }
    getSendNFTTxnObject(fromAddress, recipientAddress, { type, tokenAddress, tokenId, amount }) {
        return __awaiter(this, void 0, void 0, function* () {
            let txnObject;
            // const { gasPrice, nonce } = await this.getGasDetailsAndNonce(fromAddress);
            try {
                if (type == 'ERC1155') {
                    const { contract } = yield this.getContract(tokenAddress, undefined, erc1155_1.erc1155ABI);
                    txnObject = yield contract.populateTransaction.safeTransferFrom(fromAddress, recipientAddress, tokenId, amount, '0x'
                    // {
                    //   gasPrice,
                    //   nonce,
                    // }
                    );
                }
                else if (type == 'ERC721') {
                    console.log({ type, tokenAddress, tokenId, amount, fromAddress });
                    const { contract } = yield this.getContract(tokenAddress, undefined, erc721_1.erc721ABI);
                    txnObject = yield contract.populateTransaction.safeTransferFrom(fromAddress, recipientAddress, tokenId
                    // {
                    //   gasPrice,
                    //   nonce,
                    // }
                    );
                }
                else {
                    return { success: false, message: 'NFT type not mentioned' };
                }
                txnObject = Object.assign(Object.assign({}, txnObject), { from: fromAddress });
                return {
                    success: true,
                    txnObject,
                };
            }
            catch (err) {
                throw err;
                return {
                    success: false,
                    message: 'Error creating NFT send txn Object',
                };
            }
        });
    }
    /**
     * Bali beta specific.
     * To redeem food coupons.
     *
     */
    burnNFT(signer, { type, tokenAddress, tokenId, amount }) {
        return __awaiter(this, void 0, void 0, function* () {
            const fromAddress = yield signer.getAddress();
            let txnObject;
            if (type == 'ERC1155') {
                try {
                    const { contract } = yield this.getContract(tokenAddress, undefined, CouponsAbi_1.CouponsABI);
                    const { gasPrice, nonce } = yield this.getGasDetailsAndNonce(fromAddress);
                    txnObject = yield contract.populateTransaction.burn(tokenId, amount, { gasPrice, nonce });
                }
                catch (err) {
                    return { success: false, message: 'BURN not supported', error: err };
                }
            }
            //  else if (type == 'ERC721') {
            //   const { contract } = await this.getContract(tokenAddress, undefined, erc721ABI);
            //   txnObject = await contract.populateTransaction.burn(tokenId);
            // }
            else
                return { success: false, message: 'NFT type not supported.' };
            const txnRes = yield this.broadcastTransaction(signer, txnObject);
            return txnRes;
        });
    }
}
exports.EVM = EVM;
